import React, { useEffect } from 'react';
import closeIcon from 'assets/icons/close.svg';
import filterCheck from 'assets/icons/filterCheck.svg';


const Popup = ({ title = "Title", options, children, handleYes, handleNo, textYes, textNo, setVisible }) => {

  const closePopup = () => {
    if (setVisible && handleNo) {
      handleNo();
    } else if (setVisible) {
      setVisible(false);
    }
  }

  return (
    <div className="popup-overlay-filter">
      <div className="popup">
        <button className="mn-popup-close" onClick={closePopup}>
          <img src={closeIcon} alt="close" />
        </button>
        <div className="popup-header">
          <div className="popup-title">{title}</div>
        </div>

        {options && options.map((option, index) => (
          index % 2 !== 0 ? (
            <div className="popup-content-1" key={index}>
              {option}
              <img src={filterCheck} alt="check" />
            </div>
          ) : (
            <div className='popup-content-2' key={index}>{option}</div>
          )
        ))}
      </div>
    </div>
  );
};

export default Popup;
